/// <amd-module name="Wit/WorkItemForm/Details/WorkItemFormCommentFormatSwitch" />
import { useService } from "VSS/Platform/Layout";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";
import { Link } from "VSSUI/Link";
import * as Resources from "Wit/WorkItemForm/Resources";
import * as React from "react";

const WorkItemDiscussionSettingsKey = "WorkItemDiscussionSettings";
const CommentFormatStateKey = "CommentFormatState";
const settingsScope = SettingsUserScope.Me;
type WorkItemDiscussionSettings = {
    [CommentFormatStateKey]: WorkItemFormCommentFormatState;
};

export type WorkItemFormCommentFormatState = "Markdown" | "HTML";
export const getCurrentCommentFormatSettingAsync = (settingsService: ISettingsService): Promise<WorkItemDiscussionSettings> =>
    settingsService.getEntriesAsync(WorkItemDiscussionSettingsKey, settingsScope) as Promise<WorkItemDiscussionSettings>;
export type WorkItemFormCommentFormatSwitchProps = {
    currentFormat: WorkItemFormCommentFormatState;
    switch: (state: WorkItemFormCommentFormatState) => void;
};
export const WorkItemFormCommentFormatSwitch: React.FC<WorkItemFormCommentFormatSwitchProps> = props => {
    const settingsService = useService<ISettingsService>("ISettingsService");

    const switchEditors = React.useMemo(
        () => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            e.preventDefault();
            const targetFormat: WorkItemFormCommentFormatState = props.currentFormat === "Markdown" ? "HTML" : "Markdown";
            props.switch(targetFormat);
            const newSetting = {
                [`${WorkItemDiscussionSettingsKey}/${CommentFormatStateKey}`]: targetFormat
            };
            settingsService.setEntries(newSetting, settingsScope).catch(error => {
                // If we fail to save the setting, the user will just have to switch again to their preferred format next time they open a work item
                console.warn(error);
            });
        },
        [props.currentFormat, props.switch, settingsService]
    );

    return (
        <Link className="comment-format-switch" onClick={switchEditors}>
            {props.currentFormat === "Markdown"
                ? Resources.WorkItemCommentEditorSwitchToHTMLLinkText
                : Resources.WorkItemCommentEditorSwitchToMarkdownLinkText}
        </Link>
    );
};
